import type { BildEntscheidung } from '@awf/shared';

export interface EntscheidungsLage {
  anmerkungen: number;
  /** Ein Kommentarfeld mit geschriebenem, noch nicht uebernommenem Hinweis (Ruling 23). */
  offenerHinweis: boolean;
  gesamtFeedback: string;
  bilder: readonly BildEntscheidung[];
  rundenlimitErreicht: boolean;
}

export interface Ableitung {
  textAktion: 'approve' | 'optimize';
  knopf: 'Freigeben' | 'Zur Überarbeitung senden';
}

/**
 * Es gibt keinen Schalter "freigeben/korrigieren" mehr (Spec §6): Wer kommentiert oder ein
 * Gesamtfeedback schreibt, meint eine Korrektur. Direkte Textaenderungen allein bleiben eine
 * Freigabe mit geaendertem Text, wie bisher. Ab dem Rundenlimit gibt es fuer den Text keinen
 * Weg mehr zurueck zu n8n -- Kommentieren und Gesamtfeedback sind dann ohnehin gesperrt.
 */
export function leiteEntscheidungAb(lage: EntscheidungsLage): Ableitung {
  const textKorrektur =
    !lage.rundenlimitErreicht &&
    (lage.anmerkungen > 0 || lage.offenerHinweis || lage.gesamtFeedback.trim() !== '');
  const bildKorrektur = lage.bilder.some((b) => b.aktion === 'optimize');
  return {
    textAktion: textKorrektur ? 'optimize' : 'approve',
    knopf: textKorrektur || bildKorrektur ? 'Zur Überarbeitung senden' : 'Freigeben',
  };
}
